import { TableRow, TableCell, IconButton, Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Product } from "../../../../../models/DB";
import { KeyboardArrowDown, KeyboardArrowUp, RemoveCircle } from "@mui/icons-material";
import { Image, View } from "react-native";
import { formatTimestamp, formatUpdatedTimestamp } from "../../../../../utils/customFunctions";
import { ProductEditor } from "./ProductEditor";

interface ProductRowProps {
    product: Product;
}

export const ProductRow = ({ product }: ProductRowProps) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);

    useEffect(() => {
        if (isDeleted) {
            setOpen(false);
        }
    }, [isDeleted]);

    const IconToShow = () => {
        if (isDeleted) {
            return <RemoveCircle sx={{ color: theme.palette.error.main }} />;
        }
        return open ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
    };

    return (
        <React.Fragment>
            <TableRow
                sx={{
                    "& > *": { borderBottom: "unset" },
                    opacity: isDeleted ? 0.5 : 1,
                    backgroundColor: isDeleted
                        ? theme.palette.action.disabledBackground
                        : theme.palette.background.paper
                }}
            >
                <TableCell component="th" scope="product">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            size="small"
                            disabled={isDeleted}
                            onClick={() => setOpen(!open)}
                            sx={{ flexDirection: 'column' }}
                        >
                            <IconToShow />
                        </IconButton>
                        <View style={{
                            borderRadius: 4,
                            backgroundColor: "white",
                            justifyContent: "center",
                            alignItems: "center",
                            marginLeft: 8,
                            overflow: "hidden"
                        }}>
                        <Image
                            source={
                                product.images["thumbnail"]?.url
                                    ? { uri: product.images["thumbnail"].url }
                                    : require("../../../../../assets/no-image.png")
                            }
                            style={{
                                minHeight: 30,
                                maxHeight: 30,
                                aspectRatio: 1 / 1,
                                resizeMode: 'contain',
                            }}
                        />
                        </View>
                        <Typography variant="body2"
                            sx={{
                                marginLeft: 4,
                                fontSize: 11,
                                fontFamily: "primaryFont",
                                letterSpacing: 0.5,
                                textTransform: 'capitalize'
                            }}>
                            {product.name}
                        </Typography>
                    </Box>
                </TableCell>
                <TableCell align="right" sx={{ fontSize: 12, fontFamily: "primaryFont", letterSpacing: 0.5 }}>{product.category}</TableCell>
                <TableCell align="right" sx={{ display: { xs: 'none', md: 'table-cell' }, fontSize: 12, fontFamily: "primaryFont", letterSpacing: 0.5 }}>R {product.price}</TableCell>
                <TableCell align="right" sx={{ display: { xs: 'none', md: 'table-cell' }, fontSize: 12, fontFamily: "primaryFont", letterSpacing: 0.5 }}>{product.stockOnHand}</TableCell>
                {/* <TableCell align="right" sx={{ fontSize: 12, fontFamily: "primaryFont", letterSpacing: 0.5 }}>{formatTimestamp(product.created)}</TableCell> */}
                <TableCell align="right" sx={{ display: { xs: 'none', md: 'table-cell' }, fontSize: 12, fontFamily: "primaryFont", letterSpacing: 0.5 }}>{formatUpdatedTimestamp(product.updated)}</TableCell>
            </TableRow>
            {
                <ProductEditor
                    product={product}
                    open={open}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    setIsDeleted={setIsDeleted}
                />
            }
        </React.Fragment>
    );
};